// Button — token-driven, variants × tones × sizes.
// Variants: filled (default), tonal, outlined, text/ghost.
// Tones: primary, secondary, tertiary, neutral, danger.

import type { ButtonHTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/cn";

export type ButtonVariant = "filled" | "tonal" | "outlined" | "text" | "ghost";
export type ButtonTone = "primary" | "secondary" | "tertiary" | "neutral" | "danger";
export type ButtonSize = "sm" | "md" | "lg";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  tone?: ButtonTone;
  size?: ButtonSize;
  leadingIcon?: ReactNode;
  trailingIcon?: ReactNode;
  fullWidth?: boolean;
}

export function Button({
  variant = "filled",
  tone = "primary",
  size = "md",
  leadingIcon,
  trailingIcon,
  fullWidth,
  className,
  children,
  type = "button",
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      className={cn("lex-btn", className)}
      data-variant={variant}
      data-tone={tone}
      data-size={size}
      style={fullWidth ? { width: "100%" } : undefined}
      {...rest}
    >
      {leadingIcon ? <span className="lex-btn__icon" aria-hidden="true">{leadingIcon}</span> : null}
      {children != null ? <span>{children}</span> : null}
      {trailingIcon ? <span className="lex-btn__icon" aria-hidden="true">{trailingIcon}</span> : null}
    </button>
  );
}

export default Button;
